import {
  EventDispatcher,
} from 'three';
import { SOCKET_EVENTS } from '../../socket/Socket';
import { SCENE_EVENTS } from '../MVC/Model';
import { CHAT_EVENTS } from '../../constants/chat';

export const CHAT_NOTIFICATION = {
  CHANGED: 9001,
}


class ChatNotifications extends EventDispatcher {

  constructor({ model }) {
    super();
    this.socket = model.socket;
    this.model = model;
    this.notifications = {
      GLOBAL: 0,
      TOUR: 0,
      CURRENT_SCENE: 0,
      SCENE: {},
      PRIVATE: {},
      CHESS: {},
      total: 0,
    }

    this.socket.addEventListener(SOCKET_EVENTS.LOCAL_MESSAGE_RECEIVED, (e) => {
      if (this.model.tourIsRunning()) {
        return;
      }
      const id = e.data.data ? e.data.data.receiverId : e.data.receiverId;
      if (e.data.type && e.data.type === "SENT") {
        return;
      }
      if (!this.notifications["SCENE"][id]) {
        this.notifications["SCENE"][id] = 0;
      }
      if (!$(`#${id}.chat-container:visible`).length) {
        this.notifications["SCENE"][id] += 1;
        this.notifiy();
      }
    })
    this.socket.addEventListener(SOCKET_EVENTS.CHESS_MESSAGE_RECEIVED, (e) => {
      const receiverId = e?.data?.receiverId || e?.data?.senderId;
      if (!receiverId) {
        return;
      }
      if (!this.notifications["CHESS"][receiverId]) {
        this.notifications["CHESS"][receiverId] = 0;
      }

      if (!$(`#${receiverId}.chat-container:visible`).length) {
        this.notifications["CHESS"][receiverId] += 1;
        this.notifiy();
      }
    });
    this.socket.addEventListener(SOCKET_EVENTS.ONE_ONE_ONE_MESSAGE_RECEIVED, (e) => {
      const id = e.data.senderId || e.data.receiverId;
      if (!this.notifications["PRIVATE"][id]) {
        this.notifications["PRIVATE"][id] = 0;
      }

      if (!$(`#${id}.chat-container:visible`).length) {
        this.notifications["PRIVATE"][id] += 1;
        this.notifiy();
      }
    });
    this.socket.addEventListener(SOCKET_EVENTS.ONE_ONE_ONE_MESSAGE_SENT, (e) => {
      const id = e.data.senderId || e.data.userId;
      if (!this.notifications["PRIVATE"][id]) {
        this.notifications["PRIVATE"][id] = 0;
      }
      this.notifications["PRIVATE"][id] = 0;
      this.notifiy();
    });

    this.socket.addEventListener(SOCKET_EVENTS.MESSAGE_RECEIVED, (e) => {
      if (!this.model.chatState.globalChatVisible) {
        this.notifications["GLOBAL"] += 1;
        this.notifiy();
      }
    });
    this.socket.addEventListener(SOCKET_EVENTS.TOUR_MESSAGE_RECEIVED, (e) => {
      if (!this.model.chatState.tourChatVisible) {
        this.notifications["TOUR"] += 1;
        this.notifiy();
      }
    });

    this.model.addEventListener(CHAT_EVENTS.OPEN_ONE_ON_ONE, (e) => {
      const { id } = e.data;
      if (!this.notifications["PRIVATE"][id]) {
        this.notifications["PRIVATE"][id] = 0;
      }
      this.notifications["PRIVATE"][id] = 0;
      this.notifiy();
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_CHESS_CHAT, (e) => {
      const { id } = e.data;
      if (!this.notifications["CHESS"][id]) {
        this.notifications["CHESS"][id] = 0;
      }
      this.notifications["CHESS"][id] = 0;
      this.notifiy();
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_CHESS_CHAT, (e) => {
      const { id } = e.data;
      if (!this.notifications["CHESS"][id]) {
        this.notifications["CHESS"][id] = 0;
      }
      this.notifications["CHESS"][id] = 0;
      this.notifiy();
    });

    this.model.addEventListener(CHAT_EVENTS.CLOSE, (e) => {
      if ((!e || !e.data) || (e && e.data && !e.data.id)) {
        return;
      }
      const { id, type } = e.data;
      let _type = "SCENE"
      if (type === "PERSON") {
        _type = "PRIVATE"
      }
      if (!this.notifications[_type][id]) {
        this.notifications[_type][id] = 0;
      }
      this.notifications[_type][id] = 0;
      this.notifiy();
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_SCENE_CHAT, (e) => {
      let id = this.model.currentScene.id;
      if (e && e.id) {
        id = e.id;
      }

      if (!this.notifications["SCENE"][id]) {
        this.notifications["SCENE"][id] = 0;
      }
      this.notifications["SCENE"][id] = 0;
      this.notifiy();
    });
    this.model.addEventListener(SCENE_EVENTS.SCENE_CHANGED, (e) => {
      this.notifications.CURRENT_SCENE = 0;
      this.notifiy();
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_WORLD_CHAT, (e) => {
      this.notifications["GLOBAL"] = 0;
      this.notifiy();
    });
    this.model.addEventListener(CHAT_EVENTS.ON_OPEN_TOUR_CHAT, (e) => {
      this.notifications["TOUR"] = 0;
      this.notifiy();
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, (e) => {
      this.notifications["TOUR"] = 0;
      this.notifiy();
    });

    this.notifiy = () => {
      const id = this.model.currentScene.id;
      this.notifications.total = 0;
      this.notifications.total += this.notifications.GLOBAL;
      if (!this.model.tourIsRunning()) {
        ///sum current scene notification
        Object.keys(this.notifications.SCENE).forEach(key => {
          if (key === id) {
            this.notifications.CURRENT_SCENE = this.notifications.SCENE[key];
            this.notifications.total += this.notifications.CURRENT_SCENE;
          }
        });
        Object.keys(this.notifications.CHESS).forEach(key => {
          this.notifications.total += this.notifications.CHESS[key];
        });
      } else {
        this.notifications.total += this.notifications.TOUR
      }
      //// sum private notifications
      Object.keys(this.notifications.PRIVATE).forEach(key => {
        this.notifications.total += this.notifications.PRIVATE[key];
      });
      this.dispatchEvent({ type: CHAT_NOTIFICATION.CHANGED, data: this.notifications })
    }
  }
}

export default ChatNotifications;
